import React from 'react';

import { Box, Text } from '@r-client/shared/ui/core';

import {
  ButtonGroup,
  IButtonGroupProps,
} from '../../add-to-calendar/button-group/button-group';

export interface IAddToCalendarCardProps {
  event: IButtonGroupProps['event'];
}

export const AddToCalendarCard: React.FC<
  React.PropsWithChildren<IAddToCalendarCardProps>
> = ({ event }) => {
  return (
    <Box>
      <Text type="bodyBig" color="gray8" align="center">
        Add the event to your calendar:
      </Text>
      <ButtonGroup event={event} justifyContent="center" m="0.5brm 0 0 0" />
    </Box>
  );
};
